import Vue from 'vue'
import App from './App'
import router from './router'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import 'lib-flexible/flexible.js'
import infiniteScroll from 'vue-infinite-scroll'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'element-ui/lib/theme-chalk/index.css'
import VueLazyload from 'vue-lazyload'
import 'babel-polyfill'


const FastClick = require('fastclick')
FastClick.attach(document.body)

Vue.use(VueAwesomeSwiper)
Vue.use(infiniteScroll)

Vue.use(LoadingPlugin)
Vue.use(VueLazyload, {
preLoad: 1.3,
error: '//image.zhihuishu.com/zhs_yufa_150820/ablecommons/demo/201907/160822755ffd491ab42246c89fe60649.png',
loading: '//image.zhihuishu.com/zhs_yufa_150820/ablecommons/demo/201907/7e4f0a6c04a34c9c8922e5c338006596.png',
attempt: 1,
listenEvents: ['scroll']
})


Vue.config.productionTip = false

new Vue({
el: '#app',
router,
template: '<App />',
components: {
App
}
})














// WEBPACK FOOTER //
// ./src/main.js